<template>
    <div :class="classes">
        <el-upload
            ref="upload"
            :before-upload="beforeUpload"
            :accept="accept"
            :show-file-list="listType !== 'none'"
            :data="reqParams"
            :on-remove="handleRemove"
            :action="url"
            :on-success="successChange"
            :file-list="fileList"
            :list-type="listType"
            :disabled="disabled"
            :drag="drag"
            :on-progress="onProgress"
        >
            <i v-if="listType === 'picture-card'" class="el-icon-plus"></i>
            <div v-else-if="listType === 'text'">
                <slot></slot>
            </div>

            <div v-else-if="listType === 'none'">
                <slot></slot>
            </div>

            <div v-else-if="listType === 'fileList'">
                <slot></slot>
            </div>

            <div slot="file" slot-scope="{ file }" v-if="listType === 'picture-card'">
                <el-image :class="[`${prefix}-item-thumbnail`]" :src="file.url" fit="cover"></el-image>
                <div
                    :class="[`${prefix}-item-upload-percentage`]"
                    v-show="!(Math.round(file.percentage) >= 100)"
                >
                    <div>上传中</div>
                    <span>({{ Math.round(file.percentage) }}%)</span>
                    <el-progress :show-text="false" :percentage="Math.round(file.percentage)"></el-progress>
                </div>
                <span :class="[`${prefix}-item-actions`, 'el-upload-list__item-actions']">
                    <span
                        :class="[`${prefix}-item-preview`]"
                        @click="handlePictureCardPreview(file)"
                    >
                        <i class="el-icon-zoom-in"></i>
                    </span>
                    <span :class="[`${prefix}-item-delete`]" @click="handleRemove(file)">
                        <i class="el-icon-delete"></i>
                    </span>
                </span>
            </div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
        </el-dialog>
    </div>
</template>
<script>
// import { httpConfig } from '@/common/app.config.js';
const prefix = "u-upload";
const url = window.file_upload_baseURL;
const timestamp = +new Date();

export default {
    props: {
        files: {
            type: Array,
            default: () => [],
        },
        // 上传最大数量
        limit: {
            type: Number,
            default: 15,
        },
        // 列表类型: picture-card, text
        listType: {
            type: String,
            default: "picture-card",
        },
        // 请求地址参数
        url: {
            type: String,
            default: url,
        },
        // 请求参数
        reqParams: {
            type: Object,
            default() {
                // 文档说明, http://yapi.zookingsoft.com/project/136/interface/api/653
                return {
                    app_id: "1001",
                    relation_type: "user_info",
                    timestamp,
                    is_callback: "1",
                };
            },
        },
        accept: String,
        // 单位M
        size: {
            type: Number,
            default: 0,
        },
        imgHeight: Number,
        imgWidth: Number,
        disabled: Boolean,
        // 限制像素大小
        limitPx: Boolean,
        drag:Boolean,
    },
    data() {
        return {
            prefix,
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
            percent: 0,
            localFiles: []
        };
    },
    created() {
        let userStr = localStorage.getItem("userT") || "{}";
        let user = JSON.parse(userStr);
        Object.assign(
            this.reqParams,
            {
                sign: this.MD5(
                    encodeURIComponent(
                        [
                            1001,
                            "6iu9AtSJgGSRidOuF9lUQr7cKkW9NGrY",
                            user.open_id,
                            timestamp,
                        ].sort()
                    )
                ),
            },
            this.reqParams
        );
    },
    computed: {
        classes() {
            return [
                prefix,
                {
                    [`${prefix}-hide-upload`]:
                        this.fileList.length >= this.limit &&
                        this.listType !== "text",
                },
            ];
        },
    },
    methods: {
        handleRemove(file) {
            let idx = this.fileList.indexOf(file);
            if (~idx) {
                this.fileList.splice(idx, 1);
            } else {
                this.$refs.upload.abort(file);
            }
            this.fileListChange();
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        successChange(res, file, fileList) {
            // 异常处理
            if (res && res.result !== 0) {
                let fileIdx = fileList.indexOf(file);

                fileList.splice(fileIdx, fileIdx + 1);
                this.$message({
                    type: "error",
                    message: res.data,
                });
            }

            this.fileList = fileList;
            this.fileListChange();
        },
        fileListChange() {
            this.fileList.forEach((item) => {
                item.url = item.url || item.response.data.url;
            });
            this.$emit("change", JSON.parse(JSON.stringify(this.fileList)));
        },
        readAsDataURL(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = function (e) {
                    let data = e.target.result;
                    //加载图片获取图片真实宽度和高度
                    let image = new Image();
                    image.onload = function () {
                        let width = image.width;
						let height = image.height;
                        resolve({width, height})
                    };
                    image.src = data;
                };
                reader.readAsDataURL(file);
            });
        },
        async beforeUpload(file) {
            this.$emit('beforeUpload', file)
            if(this.size){

                let fileName = file.name.lastIndexOf(".") // 取到文件名开始到最后一个点的长度
                let fileNameLength = file.name.length // 取到文件名长度
                let fileType = file.name.substring(fileName + 1, fileNameLength)

                let fileSize = file.size / 1024;
                let limitSize = this.size * 1024;
                if (fileSize > limitSize) {
                    this.$message({
                        type: "error",
                        message: `请上传小于${this.size}M的${fileType == 'zip' ? '文件' : '图片'}`
                    });
                    throw '错误: 大于图片大小'
                // 图片分辨率判断, 图片分辨率不需要校验
                } 
            }
            if(/^image/.test(file.type)) {
                
                // 图片分辨率
                let imgPX = await this.readAsDataURL(file)

                
                
                if(imgPX.width > this.imgWidth || imgPX.height > this.imgHeight) {
                    if(this.limitPx) {
                        this.$message({
                            type: "error",
                            message: `请上传分辨率小于${this.imgWidth}*${this.imgHeight}的图片`,
                        });
                        throw '错误: 大于图片分辨率'
                    }
                }
            }
        },
        onProgress(event, file, fileList) {
            this.$emit('progress', event, file, fileList)
        }
    },
    watch: {
        files: {
            handler(val) {
                this.fileList = JSON.parse(JSON.stringify(val));
            },
            immediate: true,
        },
    },
};
</script>

<style lang="scss">
$prefixCls: u-upload;

.#{$prefixCls} {
    &-item-thumbnail {
        width: 48px;
        height: 86px;
    }
    &-item-actions {
        display: flex;
        flex-direction: column;
        padding-top: 6px;
    }
    &-item-preview {
        margin-left: 0 !important;
    }
    &-item-delete {
        margin-left: 0 !important;
    }
    &-item-upload-percentage {
        position: absolute;
        background-color: rgba($color: #000000, $alpha: 0.6);
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        text-align: center;
        line-height: normal;
        padding-top: 25px;
        font-size: 12px;
        .el-progress.el-progress--line {
            transform: translate(-50%, 0%);
            width: calc(100% - 16px);
            top: auto;
            bottom: 8px;
            .el-progress-bar {
                position: relative;
            }
        }
    }

    &-hide-upload {
        .el-upload {
            display: none;
        }
    }

    .el-upload-list--picture-card {
        .el-upload-list__item {
            width: 48px;
            height: 86px;
        }
    }
}
.el-upload-dragger{
    border: none;
    text-align: left;
}
.xx_pof .el-upload-dragger{
    height: 40px;
}
</style>
